<h2 i18n="@@DialogInvalidInputCaption">
  <mat-icon style="vertical-align: middle">error</mat-icon>&nbsp;Attenzione</h2>
<p i18n="@@DialogInvalidInputText">
  I dati inseriti non sono corretti.
</p>
<div style="margin-top: 10px; text-align: right">
  <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose">Chiudi</button>
</div>


// WEBPACK FOOTER //
// ./src/app/dialogs/invalid-input-dialog/invalid-input-dialog.html